import { render } from "./SidebarResultFooter.vue?vue&type=template&id=393063f6&scoped=true&ts=true"
import script from "./SidebarResultFooter.vue?vue&type=script&lang=ts"
export * from "./SidebarResultFooter.vue?vue&type=script&lang=ts"

import "./SidebarResultFooter.vue?vue&type=style&index=0&id=393063f6&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-393063f6"]])

export default __exports__